/* eslint-disable */
import Vue from 'vue'
import Router from 'vue-router'

// 首页
import Home from '../views/home/Home.vue'
import sharePage from '../views/home/sharePage.vue'

Vue.use(Router)

export default new Router({
    mode: 'history',
    routes: [{
            path: '*',
           redirect:'/'
        },
        {
            path: '/feiyi2',
            name: 'Home',
            component: Home,
            meta: {
                title: '',
                children: [
                    {
                        path: 'sharePage',
                        component: sharePage,
                        name: 'sharePage',
                    },
                ]
            }
        },
        {
            path: '/sharePage',
            name: 'sharePage',
            component: sharePage,
            meta: {
                parent: 'gather'
            }
        }
    ]
})


// WEBPACK FOOTER //
// ./src/feiyi2/router/index.js